import moment from "moment";
export const getPhoneObjectAsText = (
  convertedObject,
  smallClassName = "knights-employee__phone"
) => {
  let text = "";
  let keys = Object.keys(convertedObject);
  if (keys.length === 0) {
    return (
      <p className="card-text w-100 text-center">
        <small className={smallClassName}> No phone number </small>
      </p>
    );
  }
  keys.forEach(
    (key) =>
      (text =
        convertedObject[key].length > 0
          ? `${text}${convertedObject[key]},`
          : text)
  );
  text = text.replace(/,$/, "");
  return (
    <p className="card-text w-100 text-center">
      <small className={smallClassName}> {text} </small>
    </p>
  );
};

export const getCurencyFormat = (price) => {
  const numPrice = parseFloat(price);
  if (isNaN(numPrice) || price === null || price === undefined) {
    return "0";
  }
  let splitPrice = `${numPrice}`.split(".");
  if (splitPrice.length > 1) {
    return numPrice
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  } else {
    return numPrice
      .toFixed(0)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
};

export const generateRandomNumber = (n) => {
  const numberArray = [0, 1, 3, 4, 5, 6, 7, 8, 9];
  let add = 1,
    max = 12 - add; // 12 is the min safe number Math.random() can generate without it starting to pad the end with zeros.

  if (n > max) {
    let maxgent = generateRandomNumber(max);
    let nmaxgent = generateRandomNumber(n - max);
    return maxgent + nmaxgent;
  }

  max = Math.pow(10, n + add);
  let min = max / 10; // Math.pow(10, n) basically
  let number = Math.floor(Math.random() * (max - min + 1)) + min;
  number = number.toString();
  number.substring(add);
  if (number.startsWith("20") && number.length > 4) {
    const randomElement1 =
      numberArray[Math.floor(Math.random() * numberArray.length)];
    number = `${randomElement1}${number.substring(1)}`;
  }
  return parseFloat(number);
};

export const logInExpire = (loggedInTime) => {
  const dateDiffer = moment(new Date()).diff(moment(loggedInTime), "hours");
  if (isNaN(dateDiffer) || dateDiffer >= 24) {
    return true;
  }
  return false;
};
export const checkis_admin = (is_admin) => {
  if (!is_admin) {
    return false;
  }
  return true;
};
export const getPriceCurrency = (currency, price, coins, fromMain = false) => {
  const coin = coins.find(
    (coin) => coin.value.toLowerCase() === currency.toLowerCase()
  );
  if (coin) {
    if (coin.operator === "multiplication") {
      if (fromMain) {
        return price * coin.price;
      } else {
        return price / coin.price;
      }
    } else {
      if (fromMain) {
        return price / coin.price;
      } else {
        return price * coin.price;
      }
    }
  }
  return 0;
};

export const showLoading = () => {
  let loading = document.getElementById("loading");
  if (loading) {
    loading.classList.remove("d-none");
  }
};
export const hideLoading = () => {
  let loading = document.getElementById("loading");
  if (loading) {
    loading.classList.add("d-none");
  }
};

export const hideModalOnclick = (eventId, modalId) => {
  if (eventId === modalId) {
    return true;
  }
  return false;
};

export const calculatePricing = ({ buyPrice, inputValue, inputType, pricingMode, profitType }) => {
  const buyVal = parseFloat(buyPrice) || 0;
  let minProfit = 0;
  let maxProfit = 0;
  let minProfitDisplay = 0;
  let maxProfitDisplay = 0;

  if (inputType === 'min_profit') {
    if (pricingMode === 'price') {
      minProfit = parseFloat(inputValue) - buyVal;
      minProfitDisplay = parseFloat(inputValue);
    } else if (profitType === 'percentage') {
      const pct = parseFloat(inputValue) || 0;
      minProfit = buyVal > 0 ? parseFloat((buyVal * pct / 100).toFixed(2)) : 0;
      minProfitDisplay = pct;
    } else {
      minProfit = parseFloat(inputValue) || 0;
      minProfitDisplay = minProfit;
    }
  }

  if (inputType === 'max_profit') {
    if (pricingMode === 'price') {
      maxProfit = parseFloat(inputValue) - buyVal;
      maxProfitDisplay = parseFloat(inputValue);
    } else if (profitType === 'percentage') {
      const pct = parseFloat(inputValue) || 0;
      maxProfit = buyVal > 0 ? parseFloat((buyVal * pct / 100).toFixed(2)) : 0;
      maxProfitDisplay = pct;
    } else {
      maxProfit = parseFloat(inputValue) || 0;
      maxProfitDisplay = maxProfit;
    }
  }

  return { min_profit: minProfit, max_profit: maxProfit, minProfitDisplay, maxProfitDisplay };
};
